<div class="row" style="padding: 4px; background-color: #DBEAFF; border-radius: 5px;">
  <div class="col-1-icon">
    <div class="parent">
      <div class="icon">
        <em class="bi bi-exclamation-circle-fill" style="margin-right: 10px"></em>
      </div>
    </div>
  </div>
  <div class="col-11-text" style="padding: 7px 7px 7px 0">
    There are no previous {{blockName}} for the candidate
  </div>
</div>
